import React, { useEffect, useRef, useState } from "react";
import './style.scss';

const PaymentMode = (props) => {

  const [currentElementId, setCurrentElementId] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const isLoadEditData = useRef(false);
  const [paidVia, setPaidVia] = useState({
    paymentSource: "",
    cardType: "",
    bankName: "",
    upiId: "",
    mobileNumber: "",
    chequeNumber: "",
    transactionID: "",
    approvedCode: "",
    comment: ""
  });
  
  const [isPaymentSourceListOpen, setPaymentSourceListOpen] = useState(false);
  const [isCardListOpen, setCardListOpen] = useState();
  const [paymentModes, setPaymentModes] = useState([
    {
      mode : "online",
      paymentSource : [
        "NEFT",
        "RTGS",
        "IMPS",
        "Credit Card",
        "Debit Card",
        "UPI",
        "JUICE"
      ],
      cardType: [
        "Visa",
        "Mastercard",
        "Zeta",
        "Rupay",
        "Amex",
        "Bajaj Finserv",
        "Tata Card"
      ]
    },
    { 
      mode : "wallet",
      paymentSource: [
        "Paytm", 
        "MobiKwik",
        "PhonePe"
      ]
    }
  ])

  const handleSelectPaymentMode = (mode) => {
    setPaymentMode(mode)
  }

  const toggleInputFields = (id) => event => {
    setCurrentElementId(id);
    if (id == 'payment-source') setPaymentSourceListOpen(!isPaymentSourceListOpen);
    if (id == 'card-type') setCardListOpen(!isCardListOpen);
    if (event) {
      let interval = setInterval(() => {
        let element = event.target.querySelector('input');
        if (element) {
          element.focus();
          clearInterval(interval)
        }
      }, 0);
    }
  }

  const handleSelectPaymentSource = (source) => {
    setPaidVia(prevState => ({
      ...prevState,
      paymentSource: source
    }))
  }

  const handleSelectCardType = (type) => {
    setPaidVia(prevState => ({
      ...prevState,
      cardType: type
    }))
  }

  const handleChange = keyName => event => {
    
    if(keyName == "bank-name"){
      setPaidVia(prevState => ({
        ...prevState,
        bankName : event.target.value
      }))
    } else if(keyName == "upi-id"){
      setPaidVia(prevState => ({
        ...prevState,
        upiId : event.target.value
      }))
    } else if(keyName == "mobile-number"){
      setPaidVia(prevState => ({
        ...prevState,
        mobileNumber : event.target.value
      }))
    } else if(keyName == "comment"){
      setPaidVia(prevState => ({
        ...prevState,
        comment : event.target.value
      }))
    } else {
      setPaidVia(oldState =>{
        oldState[keyName] = event.target.value;
        return {...oldState};
      })
    }
  }


  useEffect(()=>{
    if(props.handlePaymentDetails){
      props.handlePaymentDetails({...paidVia,paymentMode});
    }
  },[paidVia,paymentMode])

  useEffect(()=>{
    if(props.paymentDetails && props.paymentDetails.paymentMode && !isLoadEditData.current){
      setPaymentMode(props.paymentDetails.paymentMode);
      const copyData = {...props.paymentDetails};
      
      delete copyData.paymentMode;
      setPaidVia({
        ...paidVia,
        ...copyData
      })
      isLoadEditData.current=true;
    }
  },[props]);

  return(
    <div className={`${props.actionType != "filter" ? "m-t-20" : "m-t-6"} w-full`}>
      {
        props.actionType != "filter" ? (
          <p className="flex-item font-weight-700 color-dark-blue m-b-2">Payment Mode</p>
        ) : (
          <p className="flex-item fs-16 font-weight-700 m-b-2">Payment Mode</p>
        )
      }
      <div className="d-flex space-between m-b-12">
        <div onClick={()=>handleSelectPaymentMode("online")} className="d-flex">
          <input className="flex-item m-r-4" name="payment-mode" type="radio" checked={paymentMode == "online"} />
          <p className="flex-item fs-12">Online</p>
        </div>
        <div onClick={()=>handleSelectPaymentMode("wallet")} className="d-flex">
          <input className="flex-item m-r-4" name="payment-mode" type="radio" checked={paymentMode == "wallet"}/>
          <p className="flex-item fs-12">Wallet</p>
        </div>
        <div onClick={()=>handleSelectPaymentMode("cheque")} className="d-flex">
          <input className="flex-item m-r-4" name="payment-mode" type="radio" checked={paymentMode == "cheque"}/>
          <p className="flex-item fs-12">Cheque</p>
        </div>
        <div onClick={()=>handleSelectPaymentMode("cash")} className="d-flex">
          <input className="flex-item m-r-4" name="payment-mode" type="radio" checked={paymentMode == "cash"}/>
          <p className="flex-item fs-12">Cash</p>
        </div>
        <div onClick={()=>handleSelectPaymentMode("other")} className="d-flex">
          <input className="flex-item m-r-4" name="payment-mode" type="radio" checked={paymentMode == "other"}/>
          <p className="flex-item fs-12">Other</p>
        </div>
      </div>
      {
        paymentMode != "cash" && (
          <div className="w-full">
            {
              (paymentMode == "online" || paymentMode == "wallet") && (
                <div onClick={toggleInputFields('payment-source')} className={`${(currentElementId == "payment-source" || paidVia.paymentSource) ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: (currentElementId == "payment-source" || paidVia.paymentSource) ? "1px solid var(--darkBlue)" : "" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "payment-source" || paidVia.paymentSource) ? "10px" : "14px", color: (currentElementId == "payment-source" || paidVia.paymentSource) ? "var(--darkBlue)" : "", transition: "180ms" }}>Payment Source</p>
                  </div>
                  <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                    <svg className="flex-item" style={{ transform: isPaymentSourceListOpen ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                    </svg>
                  </div>
                  <input id="payment-source" className={`${(currentElementId == "payment-source" || paidVia.paymentSource) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select Payment Source" value={paidVia.paymentSource} style={{ pointerEvents: "none", textTransform: 'capitalize' }} disabled/>
                  {
                    isPaymentSourceListOpen && (
                      <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                        {
                          paymentModes[paymentMode == "online" ? 0 : 1].paymentSource.map((source, index) => {
                            return(
                              <div onClick={()=>handleSelectPaymentSource(source)} className="global-input-field-arrow-dropdown-item">
                                <p className="flex-item">{source}</p>
                              </div>
                            )
                          })
                        }
                      </div>
                    )
                  }
                </div>
              )
            }

            {
              (paidVia.paymentSource == "NEFT" || paidVia.paymentSource == "RTGS" || paidVia.paymentSource == "IMPS" || paymentMode == "cheque") && (
                <div onClick={toggleInputFields('bank-name')} className={`${(currentElementId == 'bank-name' || paidVia.bankName) ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field flex-item m-b-12 d-flex"}`} style={{ border: (currentElementId == 'bank-name' || paidVia.bankName) ? "1px solid var(--darkBlue)" : "" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'bank-name' || paidVia.bankName) ? "10px" : "14px", color: (currentElementId == 'bank-name' || paidVia.bankName) ? "var(--darkBlue)" : "", transition: "180ms" }}>Bank Name</p>
                  </div>
                  <input value={paidVia.bankName} className={`${(currentElementId == 'bank-name' || paidVia.bankName) ? "active-input-field" : "inactive-input-field"}`} type="text" onChange={handleChange("bank-name")} />
                </div>
              )
            }

            {
              (paidVia.paymentSource == "Credit Card" || paidVia.paymentSource == "Debit Card") && (
                <div onClick={toggleInputFields('card-type')} className={`${(currentElementId == "card-type" || paidVia.cardType) ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: (currentElementId == "card-type" || paidVia.cardType) ? "1px solid var(--darkBlue)" : "" }}>
                <div className="flex-item d-flex">
                  <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "card-type" || paidVia.cardType) ? "10px" : "14px", color: (currentElementId == "card-type" || paidVia.cardType) ? "var(--darkBlue)" : "", transition: "180ms" }}>Card Name</p>
                </div>
                <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                  <svg className="flex-item" style={{ transform: isPaymentSourceListOpen ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                  </svg>
                </div>
                <input id="card-type" className={`${(currentElementId == "card-type" || paidVia.cardType) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select Payment Source" value={paidVia.cardType} style={{ pointerEvents: "none", textTransform: 'capitalize' }} disabled/>
                {
                  isCardListOpen && (
                    <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                      {
                        paymentModes[0].cardType.map((type, index) => {
                          return(
                            <div onClick={()=>handleSelectCardType(type)} className="global-input-field-arrow-dropdown-item">
                              <p className="flex-item">{type}</p>
                            </div>
                          )
                        })
                      }
                    </div>
                  )
                }
                </div>
              )
            }

            {
              (paidVia.paymentSource == "UPI") && (
                <div onClick={toggleInputFields('upi-id')} className={`${(currentElementId == 'upi-id' || paidVia.upiId) ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field flex-item m-b-12 d-flex"}`} style={{ border: (currentElementId == 'upi-id' || paidVia.upiId) ? "1px solid var(--darkBlue)" : "" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'upi-id' || paidVia.upiId) ? "10px" : "14px", color: (currentElementId == 'upi-id' || paidVia.upiId) ? "var(--darkBlue)" : "", transition: "180ms" }}>UPI ID</p>
                  </div>
                  <input value={paidVia.upiId} className={`${(currentElementId == 'upi-id' || paidVia.upiId) ? "active-input-field" : "inactive-input-field"}`} type="text" onChange={handleChange("upi-id")} />
                </div>
              )
            }

            {
              (paidVia.paymentSource == "Paytm" || paidVia.paymentSource == "MobiKwik" || paidVia.paymentSource == "PhonePe" || paymentMode == "other") && (
                <div onClick={toggleInputFields('mobile-number')} className={`${(currentElementId == 'mobile-number' || paidVia.mobileNumber) ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field flex-item m-b-12 d-flex"}`} style={{ border: (currentElementId == 'mobile-number' || paidVia.mobileNumber) ? "1px solid var(--darkBlue)" : "" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'mobile-number' || paidVia.mobileNumber) ? "10px" : "14px", color: (currentElementId == 'mobile-number' || paidVia.mobileNumber) ? "var(--darkBlue)" : "", transition: "180ms" }}>Mobile Number</p>
                  </div>
                  <input value={paidVia.mobileNumber} className={`${(currentElementId == 'mobile-number' || paidVia.mobileNumber) ? "active-input-field" : "inactive-input-field"}`} type="number" onChange={handleChange("mobile-number")} />
                </div>
              )
            }

            {
              !props.actionType == "filter" && paymentMode == "other" && (
                <div onClick={toggleInputFields('comment')} className={`${(currentElementId == 'comment' || paidVia.comment) ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field flex-item m-b-12 d-flex"}`} style={{ border: (currentElementId == 'comment' || paidVia.comment) ? "1px solid var(--darkBlue)" : "" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'comment' || paidVia.comment) ? "10px" : "14px", color: (currentElementId == 'comment' || paidVia.comment) ? "var(--darkBlue)" : "", transition: "180ms" }}>Comment</p>
                  </div>
                  <input value={paidVia.comment} className={`${(currentElementId == 'comment' || paidVia.comment) ? "active-input-field" : "inactive-input-field"}`} type="text" onChange={handleChange("comment")} />
                </div>
              )
            }


            {
              (!props.actionType == "filter" && paymentMode != "other") && (
                <div onClick={toggleInputFields('transaction-id')} className={`${(currentElementId == 'transaction-id' || paidVia.transactionID) ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field flex-item m-b-12 d-flex"}`} style={{ border: (currentElementId == 'transaction-id' || paidVia.transactionID) ? "1px solid var(--darkBlue)" : "" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'transaction-id' || paidVia.transactionID) ? "10px" : "14px", color: (currentElementId == 'transaction-id' || paidVia.transactionID) ? "var(--darkBlue)" : "", transition: "180ms" }}>Transaction ID</p>
                  </div>
                  <input value={paidVia.transactionID} className={`${(currentElementId == 'transaction-id' || paidVia.transactionID) ? "active-input-field" : "inactive-input-field"}`} type="text" onChange={handleChange("transactionID")} />
                </div>
              )
            }
          </div>
        )
      }
    </div>
  )
}

export default PaymentMode;